import { render, staticRenderFns } from "./ReailzeCard.vue?vue&type=template&id=7dd12bc3&scoped=true&"
import script from "./ReailzeCard.vue?vue&type=script&lang=js&"
export * from "./ReailzeCard.vue?vue&type=script&lang=js&"
import style0 from "./ReailzeCard.vue?vue&type=style&index=0&id=7dd12bc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd12bc3",
  null
  
)

export default component.exports